/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Page from 'material/structure/page/page';
import Content from 'material/structure/content/content';
import FlowControls from 'material/embeds/flowcontrols/flowcontrols_container'
import EmbedControls from 'material/embeds/embedcontrols/embedcontrols_container';
import NewContentCTA from 'material/ctas/newcontent/newcontent_container';
import EmbedProperties from 'pages/dashboard/embeds/management/customize/embedproperties/embedproperties_container';
import PageProperties from 'pages/dashboard/embeds/management/customize/pageproperties/pageproperties_container';
import EmbedEditor from 'pages/dashboard/embeds/management/customize/embededitor/embededitor_container';
import ContentSelector from 'pages/dashboard/embeds/management/customize/contentselector/contentselector_container';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/customize/customize_styles';



/* ========== ~~~~~~~~~~ PAGE : CUSTOMIZE : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class CustomizePage extends Component {
    isStep() {
        return this.props.currentStepPage !== null || this.props.currentStepPage !== undefined ? 'step' : 'standard';
    }
    showPlacement() {
        return this.props.location === 'in-content' ? 'incontent' : 'rail';
    }
    /* /////////////// RENDER \\\\\\\\\\\\\\\ */
    render() {
        return (
            <Page name={`customize`} klass={`${this.props.classes.customize} ${this.isStep()} ${this.showPlacement()}`}>
                <Content>
                    <EmbedControls handleSaveEmbed={this.props.handleSaveEmbed} />
                    <div className={`grouper`}>
                        <div className={`group`}>
                            <PageProperties />
                        </div>
                        <div className={`group`}>
                            <EmbedEditor />
                            <NewContentCTA />
                        </div>
                        <div className={`group`}>
                            <EmbedProperties />
                        </div>
                    </div>
                </Content>
                <div className={'controls'}>
                    <FlowControls handleSaveEmbed={this.props.handleSaveEmbed} />
                    {this.props.content && <ContentSelector />}
                </div>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(CustomizePage);
